<script setup lang="ts">
import type { IMissionDB } from '@/types/mission';

import Modal from "@/dsComponents/modals/Modal.vue";

import InterimMiniRead from "@/components/interim/InterimMiniRead.vue";

// Props
interface Props {
    // biome-ignore lint/suspicious/noExplicitAny: Init Biome
    interimId: any;
    mission: IMissionDB;
    open: boolean;
}

defineProps<Props>();

const emit = defineEmits<(e: "close") => void>();
</script>

<template>
    <Modal width="80%" :open="open" :action="true" @close="emit('close')">
        <InterimMiniRead :mission="mission" :interimId="interimId" @close="emit('close')" />
    </Modal>
</template>
